import { atom } from 'jotai'
import type { Moment } from '@/utils'
import { createMoment } from '@/utils'
import { runnerAtom } from './runner.store.ts'
import { nowAtom, getNowAtom } from '@/shared/store/clock.store'
import { tickAtom } from '@/shared/store/tick.store'

/**
 * Public moment atom - recalculates on every tick
 * Components subscribing to this will re-render every 100ms
 */
export const momentAtom = atom<Moment | null>((get) => {
  const runner = get(runnerAtom)
  const now = get(nowAtom)

  // Subscribe to tick atom to trigger re-render
  get(tickAtom)

  if (!runner?.timesnap) {
    return null
  }

  // Create moment with current tick time
  return createMoment(runner.timesnap, now)
})

/**
 * Atom to get moment without tick subscription
 * Use this when you need moment data but don't want tick-based re-renders
 */
export const momentStaticAtom = atom<Moment | null>((get) => {
  const runner = get(runnerAtom)
  const getNow = get(getNowAtom)

  if (!runner?.timesnap) {
    return null
  }

  // Create moment with Date.now() - won't update on ticks
  return createMoment(runner.timesnap, getNow())
})
